import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { ApplyAsCandidateModal } from '../../candidate-apply-form/modals';
import { ApplyAsAgencyModal } from '../../agency-apply-form/modals';
import { WrapperReduxStore } from '../../shared/components';

export const VacancyDetails = ({
    locations,
    salary,
    bonuses,
    jobLevel,
}) => {
    const { t } = useTranslation('PayseraRecruitmentBundle');

    return (
        <div className="vacancy-details">
            {!!jobLevel?.name && (
                <>
                    <p className="vacancy-details-title">{t('career_offer.seniority_level')}</p>
                    <p>{jobLevel.name}</p>
                </>
            )}
            {locations && (
                <>
                    <p className="vacancy-details-title">{t('career_offer.location')}</p>
                    <p>{locations}</p>
                </>
            )}
            {salary && (
                <>
                    <p className="vacancy-details-title">{t('career_offer.salary')}</p>
                    <p>{salary}</p>
                </>
            )}
            {!!bonuses && (
                <>
                    <p className="vacancy-details-title">{t('career_offer.bonuses')}</p>
                    <p>{bonuses}</p>
                </>
            )}
            <hr />
            <p className="large-text">
                <strong>{t('career_offer.interested')}</strong>
            </p>
            <div className="vacancy-details-apply">
                <WrapperReduxStore>
                    <ApplyAsCandidateModal />
                </WrapperReduxStore>
                <WrapperReduxStore>
                    <ApplyAsAgencyModal />
                </WrapperReduxStore>
            </div>
        </div>
    );
};

VacancyDetails.propTypes = {
    locations: PropTypes.string,
    salary: PropTypes.string,
    bonuses: PropTypes.string,
    jobLevel: PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.number,
        created_at: PropTypes.string,
        updated_at: PropTypes.string,
    }),
};

VacancyDetails.defaultProps = {
    locations: null,
    salary: null,
    bonuses: undefined,
    jobLevel: undefined,
};
